import catalog from "../../../data/catalog.json";
import type { Product } from "./types";
export const products: Product[] = catalog as Product[];
export const defaultProductIds = products.slice(0, 11).map((p) => p.id);
export const defaultCategoryIds = ["jellycat_bag_charm"];
export const productById = (id: string | null) =>
  products.find((p) => p.id === id);
export const buddyStage = (fed: number) =>
  fed >= 30 ? 4 : fed >= 15 ? 3 : fed >= 5 ? 2 : fed >= 1 ? 1 : 0;
export const buddyStages = [
  "Happy little pup",
  "Happy little pup",
  "Pleasantly plump",
  "Professional snacker",
  "Certified cozy loaf",
];
